/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputOtgShort
 */
export interface OutputOtgShort {
    /**
     * 
     * @type {number}
     * @memberof OutputOtgShort
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputOtgShort
     */
    name: string;
}

/**
 * Check if a given object implements the OutputOtgShort interface.
 */
export function instanceOfOutputOtgShort(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputOtgShortFromJSON(json: any): OutputOtgShort {
    return OutputOtgShortFromJSONTyped(json, false);
}

export function OutputOtgShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputOtgShort {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputOtgShortToJSON(value?: OutputOtgShort | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

